import { render, staticRenderFns } from "./CustomerInfo2Beta.vue?vue&type=template&id=6a3ba175&scoped=true"
import script from "./CustomerInfo2Beta.vue?vue&type=script&lang=js"
export * from "./CustomerInfo2Beta.vue?vue&type=script&lang=js"
import style0 from "./CustomerInfo2Beta.vue?vue&type=style&index=0&id=6a3ba175&prod&lang=scss"
import style1 from "./CustomerInfo2Beta.vue?vue&type=style&index=1&id=6a3ba175&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3ba175",
  null
  
)

export default component.exports